// frontend/src/components/admin/SiteAnalyticsTab.tsx
//
// Site Analytics (Product & Marketing). Self-hosted, cookieless, consent-gated
// web + product analytics:
//   - Web traffic (page_views): totals, by-day trend, top pages, top referrers
//   - Product events (analytics_events): top events, by-day, signed-in attribution
// Distinct from the "Analytics" tab, which covers platform/user/trip metrics.
import React from 'react';
import { Box, Typography } from '@mui/material';
import WebTrafficCard from './WebTrafficCard';
import EventsCard from './EventsCard';

const SiteAnalyticsTab: React.FC = () => {
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>Site Analytics</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Self-hosted, privacy-friendly web traffic and product-event analytics. Cookieless and
        consent-gated; bots excluded. Signed-in attribution shown where available.
      </Typography>
      <WebTrafficCard />
      <EventsCard />
    </Box>
  );
};

export default SiteAnalyticsTab;
